import React from 'react';
import BreadcrumbWithWrapper from '@repo/ui-components/BreadcrumbWithWrapper';
import { useUiComponentsInternationalContext } from '@repo/static-translations/src';

const useAlgoliaSearchBreadcrumb = (nbHits, searchState) => {
  const { tt } = useUiComponentsInternationalContext();
  return (
    <BreadcrumbWithWrapper
      elements={[
        {
          text: tt(s => s.algoliaSearchBreadcrumbComponent.homeBreadcrumbLabel),
          link: '/',
        },
        {
          text: searchState.query
            ? tt(
                s =>
                  s.algoliaSearchBreadcrumbComponent
                    .searchResultsBreadcrumbLabel,
                {
                  results: nbHits,
                  query: searchState.query,
                }
              )
            : tt(
                s =>
                  s.algoliaSearchBreadcrumbComponent
                    .searchResultsWithoutQueryBreadcrumbLabel
              ),
          link: '/search',
        },
      ]}
    />
  );
};

export default useAlgoliaSearchBreadcrumb;
